module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('note-list', {
    attrs: {
      "with-add": false,
      "client": _vm.clientObject,
      "appointment": _vm.appointment
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.openGlobalDialog(true, "Notes", {
          appointment: _vm.appointment
        })
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Add a note\n      ")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3342a1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/detail/NotesTab.vue
// module id = 1526
// module chunks = 9